import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useHideNativeNavigation, useHideWebHeader } from '@/layout/providers/LayoutProvider'
import { openUrl } from '@/utils/external-resources'
import { ContentItemDetailLayout } from '../../components/ContentItemDetailLayout'
import { RichText } from '../../components/RichText'
import { useContentById } from '../../hooks/useContent'

type Props = {
  preview?: boolean
  draft?: boolean
}

export const ArticleDetailPage = ({ preview, draft }: Props) => {
  const { id } = useParams()
  const navigate = useNavigate()

  const { data: article, isLoading } = useContentById(id, draft)

  // Hide navigation on native devices
  useHideWebHeader()
  useHideNativeNavigation()

  useEffect(() => {
    const linkedUrl = article?.linkedEntry?.[0]?.url
    if (linkedUrl) {
      openUrl(linkedUrl)
    }
  }, [article?.linkedEntry])

  return (
    <ContentItemDetailLayout
      loading={isLoading}
      bannerUrl={article?.featuredImage?.url}
      onGoBack={preview ? undefined : () => navigate(-1)}
      preview={preview}
    >
      {article?.contentBlocks ? <RichText contentBlocks={article.contentBlocks} /> : null}
    </ContentItemDetailLayout>
  )
}
